import { useWebSocketContext } from './WebSocketContext.js';
import { WebSocketEvent } from '@laxmi-ai/shared';

export function useWebSocket(): {
  connected: boolean;
  send: (event: WebSocketEvent, payload: unknown) => void;
  subscribe: (event: string, handler: (payload: unknown) => void) => void;
  unsubscribe: (event: string, handler: (payload: unknown) => void) => void;
} {
  return useWebSocketContext();
}